function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h240v240H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M122.53 46.308c0 10.157 8.243 18.39 18.411 18.39 10.168 0 18.411-8.233 18.411-18.39 0-9.48-7.18-17.283-16.403-18.283-.44-.047-4.326 2.236-11.661 6.85l-8.758 11.433zm20.04 138.739a28.67 28.67 0 00-4.117 14.846c0 15.922 12.921 28.829 28.86 28.829 11.511 0 21.448-6.732 26.081-16.469l-11.68-8.506-11.15-6.353-27.994-12.347z",
  fill: "#FFB74D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M215.206 236.074c17.856-29.821 22.9-68.17 3.633-120.856-1.587-4.34-3.223-8.37-4.908-12.088-3.991-11.69-8.865-23.765-14.445-34.86.307-1.82.467-3.683.467-5.58 0-9.203-3.754-17.616-9.959-24.065 6.886-20.26-15.224-40.537-16.417-35.642-1.122 4.602-.258 10.8-7.154 23.526a45.471 45.471 0 00-7.29-.585c-16.516 0-30.741 8.835-37.168 21.543-20.96-1.108-35.407.375-43.341 4.45-3.958 1.837-10.167 25.91 13.174 37.257 1.795 1.282 15.497 1.845 41.107 1.691a41.39 41.39 0 006.78 4.16c21.24 34.732 7.587 56.51-40.956 65.334-48.755 8.862-77.246 35.069-85.475 78.62l-.04.932",
  stroke: "#371447",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M219.382 113.693c-17.18 9.134-29.729 13.828-37.644 14.082-7.915.254-18.04-1.666-33.199-6.636M45.465 105.31c3.622-6.692 5.045-11.887 4.27-15.584-.775-3.698 2.055-4.062 8.491-1.093-.169 8.35-.66 12.686-1.474 13.01-.814.323-4.576 1.545-11.287 3.666z",
  stroke: "#371447",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.776 240.04c.005-1.634-.63-2.625-1.346-4.443-7.552-19.182-8.415-39.445-2.067-57.746a68.132 68.132 0 01-9.49-4.557c-1.452.134-3.177.18-5.222.137-18.59-.397-30.12-8.24-30.12-19.94 0-3.885.976-5.277 2.522-7.079 1.707-1.99 5.358-5.342 9.606-7.964a38.868 38.868 0 011.673-9.284c4.368-14.113 16.537-24.838 31.514-27.221 2.641-8.581-.43-19.878 5.056-17.894 5.487 1.985 15.943 14.526 21.158 22.717 11.76 6.805 19.663 19.456 19.663 33.939 0 2.974-.483 5.93-1.352 8.808 6.21 12.55 17.412 23.012 33.607 31.384 24.224 12.523 58.927 21.202 79.668 55.199.49.803.361 2.524.312 3.792",
  stroke: "#371447",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#371447",
  strokeWidth: 3,
  fill: "#FFB74D",
  cx: 58.971,
  cy: 180.964,
  rx: 5.971,
  ry: 5.964
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#371447",
  cx: 36.905,
  cy: 138.557,
  rx: 3.981,
  ry: 3.976
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.593 154.517c2.241 0 6.576-2.866 6.576-5.193 0-2.326-3.838-3.808-6.08-3.808-2.241 0-4.058 1.886-4.058 4.213 0 2.326 1.32 4.788 3.562 4.788z",
  fill: "#371447"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#371447",
  cx: 138.621,
  cy: 49.842,
  rx: 3.981,
  ry: 3.976
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#371447",
  strokeWidth: 3,
  fill: "#FFB74D",
  cx: 180.641,
  cy: 134.426,
  rx: 5.971,
  ry: 5.964
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.673 63.427c3.121 0 9.159-3.816 9.159-6.913 0-3.098-5.346-5.07-8.467-5.07-3.122 0-5.652 2.51-5.652 5.608s1.838 6.375 4.96 6.375z",
  fill: "#371447"
}));

function SvgPetsXl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgPetsXl;